import CryptoJS from 'crypto-js'

// 定义加密解密相关的类型
export type Encryptable = string | number | boolean | null | undefined | Encryptable[]

// 加密密钥；后端的路由用的此密钥；不能修改！！！
function getEncryptionKey(): string {
  return '1iM2r0ebICBeXAdg'
}

const encryptionKey = getEncryptionKey() // 仅初始化一次，避免重复调用

const encodeReserveRE = /[!'()*]/g
const encodeReserveReplacer = (c: string) => '%' + c.charCodeAt(0).toString(16)
const commaRE = /%2C/g

const encode = (str: string): string =>
  encodeURIComponent(str).replace(encodeReserveRE, encodeReserveReplacer).replace(commaRE, ',')

const decode = decodeURIComponent

// 加密方法
export function encrypt(word: string): string {
  try {
    const key = CryptoJS.enc.Utf8.parse(encryptionKey)
    const srcs = CryptoJS.enc.Utf8.parse(word)
    const encrypted = CryptoJS.AES.encrypt(srcs, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    return encrypted.toString()
  } catch (error) {
    console.error('Encryption error:', error)
    throw error // 或者根据策略处理错误
  }
}

// 解密方法
export function decrypt(ciphertext: string): string {
  try {
    const key = CryptoJS.enc.Utf8.parse(encryptionKey)
    const decrypt = CryptoJS.AES.decrypt(ciphertext, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    return CryptoJS.enc.Utf8.stringify(decrypt).toString()
  } catch (error) {
    console.error('Decryption error:', error)
    throw error // 或者根据策略处理错误
  }
}

// 加密参数
export function stringifyQuery<T extends Record<string, any>>(obj: T): string {
  if (Object.keys(obj).length === 0) {
    return ''
  }
  const encodedParts = Object.entries(obj)
    .map(([key, value]) => {
      if (value === undefined) {
        return ''
      }
      if (Array.isArray(value)) {
        return value
          .map((val) => (val !== null ? `${encode(key)}=${encode(val)}` : encode(key)))
          .filter(Boolean)
          .join('&')
      }
      return `${encode(key)}=${encode(value)}`
    })
    .filter(Boolean)

  return encodedParts.length ? `${encrypt(encodedParts.join('&'))}` : ''
}

// 解密参数
export function parseQuery(query: string): Record<string, any> {
  const res: Record<string, any> = {}

  try {
    const decryptedQuery = decrypt(query.trim())
    decryptedQuery.split('&').forEach((param) => {
      const [key, val] = param.split('=')
      const decodedKey = decode(key)
      const decodedVal = val ? decode(val) : null

      if (!res[decodedKey]) {
        res[decodedKey] = decodedVal
      } else if (Array.isArray(res[decodedKey])) {
        res[decodedKey].push(decodedVal)
      } else {
        res[decodedKey] = [res[decodedKey], decodedVal]
      }
    })
  } catch (error) {
    console.error('Query parsing error:', error)
    // 根据需要处理错误
  }

  return res
}

export function openTabByCryptoQuery(path: string, query: Record<string, any>) {
  const p = import.meta.env.VITE_APP_BASE_PATH
  const newUrl = `${location.origin}/${p}${path}?${stringifyQuery(query)}`
  window.open(newUrl, '_blank')
}
